import { z } from 'zod';
export var AllPaymentProvidersEnum;
(function (AllPaymentProvidersEnum) {
    AllPaymentProvidersEnum["CASH"] = "CASH";
    AllPaymentProvidersEnum["STRIPE"] = "STRIPE";
    AllPaymentProvidersEnum["TILLED"] = "TILLED";
    AllPaymentProvidersEnum["PAYFACTORY"] = "PAYFACTORY";
    AllPaymentProvidersEnum["BLOCKCHYP"] = "BLOCKCHYP";
    AllPaymentProvidersEnum["DEBT"] = "DEBT";
    AllPaymentProvidersEnum["GENERIC"] = "GENERIC";
    AllPaymentProvidersEnum["NORTH"] = "NORTH";
    // CLOVER = 'CLOVER',
    // PAYPAL = 'PAYPAL',
    // SQUARE = 'SQUARE',
    // CASH_APP = 'CASH_APP',
    // ZELLE = 'ZELLE',
    // APPLE_PAY = 'APPLE_PAY',
    // GOOGLE_PAY = 'GOOGLE_PAY',
    // OTHER = 'OTHER',
})(AllPaymentProvidersEnum || (AllPaymentProvidersEnum = {}));
export const AllPaymentProviderSchema = z.nativeEnum(AllPaymentProvidersEnum);
